import { render } from "./TooltipWrap.vue?vue&type=template&id=74fa13b4"
import script from "./TooltipWrap.vue?vue&type=script&lang=js"
export * from "./TooltipWrap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__